import React, { useEffect } from 'react';
import { view } from 'react-easy-state';
import ModalVideo from 'react-modal-video';
import mostVisible from 'most-visible';

import { baseStore } from '../store';

import Layout from '../components/layout';

import Hero from '../components/hero';
import TopLinks from '../components/toplinks';
import Friends from '../components/friends/friends';
import Videos from '../components/videos/videos';
import Albums from '../components/albums/albums';
import Footer from '../components/footer';

let ticking = false;

const IndexPage = () => {
  useEffect(() => {
    baseStore.windowHeight = window.innerHeight;
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        const el = mostVisible(document.querySelectorAll('.site-section'));

        if (el) {
          baseStore.section = el.id;
        }

        ticking = false;
      });

      ticking = true;
    }
  };

  return (
    <Layout>
      <div id="top" />

      <Hero />

      <TopLinks />

      <div css={{ height: '4rem' }} />

      <Friends />

      <Videos />

      <Albums />

      <Footer />

      <ModalVideo
        channel="youtube"
        isOpen={baseStore.videoOpen}
        videoId={baseStore.videoId}
        onClose={() => {
          baseStore.videoOpen = false;
        }}
      />
    </Layout>
  );
};

export default view(IndexPage);
